import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IRemotePower } from 'app/interfaces/IRemotePower';
import { IUserDefArea } from 'app/interfaces/IUserDefArea';
import { KeycloakService } from 'app/login/keycloak.service';
import { Mapapi } from 'app/ol-map/mapapi';
import { EventsService } from 'app/_services/events.service';
import { GlobalsService } from 'app/_services/globals.service';
import { LayersService } from 'app/_services/layers.service';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { TabledataService } from 'app/_services/tabledata.service';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import WKT from 'ol/format/WKT';
import { always, doubleClick } from 'ol/events/condition';



@Component({
    selector: 'app-remote-power',
    templateUrl: './remote-power.component.html',
    styleUrls: ['./remote-power.component.css'],
    providers: [RemotePowerService],
    standalone: false
})
export class RemotePowerComponent implements OnInit, AfterViewInit, OnChanges {
  @Output() onCloseEmmiter: EventEmitter<any> = new EventEmitter<any>()
  @Input() doFindOptsSelected: any = 1;
  @Input() infoEvent: any = null;
  doFindOpts: SelectItem[] = [{ label: 'Iskanje   primernega   območja', value: 1 }, { label: 'Lastna izbira območja', value: 2 }];
  drawopts: SelectItem[] = [{ label: 'Izriši območje', value: 1 }, { label: 'Popravi območje', value: 2 }, { label: 'Počisti območje', value: 3 }, { label: 'Zaključi', value: 4 }];
  drawoptselected: any = null;
  
  midparameter: number;
  obmidsparameter: string;
  systemSizeTypes: Array<{ id: number, opis_velikosti_sistema: string, selected: boolean }> = null;
  statusActions: any[] = []
  drawInteraction: any;
  vectorDrawLayer: any;
  modifyInteraction: any;
  roofTopPowerPlant: SelectItem[] = [{ label: 'Najdi po naslovu', value: 1 }, { label: 'Najdi ustrezne objekte', value: 2 }];
  selectedRoofTopPowerPlant: any = 1;
  status


  sumConsumption = 0;
  consumptionShareStateBuildingsMAX = 0;
  consumptionShareMunicipalityBuildingsMAX = 0;
  consumptionShareMultiAppartmentBuildingsMAX = 0;
  consumptionShareProductionBuildingsMAX = 0;
  consumptionShareBusinessBuildingsMAX = 0;
  consumptionShareTouristicBuildingsMAX = 0;

  remotePowerForm = this.formBuilder.group({
    minConsumptionNetwork: false,
    minConsumptionNetworkValue: 0.8,
    minConsumptionArea: false,
    minConsumptionAreaValue: 139,

    isStateBuilding: false,
    isMunicipality: false,
    isProduction: false,
    isApartments: false,
    isBusiness: false,
    isTouristic: false,


    // isShareCheapestSystem: false,
    // isShareCheapetHeat4Consumer: false,
    // isShareLowestCo2Emissions: false,
    // isShareMinConsumtionBasicEnergy: false,
    // isShareMaxOVEShare: false,

    consumptionShareStateBuildings: [0, [Validators.min(0), Validators.max(100)]],
    consumptionShareMunicipalityBuildings: [0, [Validators.min(0), Validators.max(100)]],
    consumptionShareMultiAppartmentBuildings: [0, [Validators.min(0), Validators.max(100)]],
    consumptionShareProductionBuildings: [0, [Validators.min(0), Validators.max(100)]],
    consumptionShareBusinessBuildings: [0, [Validators.min(0), Validators.max(100)]],
    consumptionShareTouristicBuildings: [0, [Validators.min(0), Validators.max(100)]],



    // shareCheapestSystem: [0, [Validators.min(0), Validators.max(100)]],
    // shareCheapetHeat4Consumer: [0, [Validators.min(0), Validators.max(100)]],
    // shareLowestCo2Emissions: [0, [Validators.min(0), Validators.max(100)]],
    // shareMinConsumtionBasicEnergy: [0, [Validators.min(0), Validators.max(100)]],
    // shareMaxOVEShare: [0, [Validators.min(0), Validators.max(100)]],

  });
  constructor(
    private formBuilder: FormBuilder,
    private layersService: LayersService,
    private remotePowerService: RemotePowerService,
    private eventService: EventsService,
    private mapApi: Mapapi,
    private globalService: GlobalsService,
    private tableService: TabledataService,
    private messageService: MessageService
  ) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (this.infoEvent && this.vectorDrawLayer) {
      this.vectorDrawLayer.getSource().addFeature(this.infoEvent.feature);
      this.drawAction({ value: 2 }, null);
      this.drawoptselected = 2;
    }
  }

  ngOnInit() {

    this.remotePowerForm.valueChanges.subscribe(changes => {
      console.warn(changes)
      this.sumConsumption = this.calcSumConsumption(changes);
      this.maxConsumtionLogic();
    })
    this.remotePowerService.getRemotePowerSizeTypes().subscribe({
      next: sizeTypes => {
        this.systemSizeTypes = sizeTypes.map(type => {
          return { ...type, selected: false }
        });
      },
      error: err => console.error(err)
    })
    this.layersService.subscribeLayersGroupLoadListener().subscribe(
      data => {
        if (data.ob_mid !== undefined) {
          // console.log("load layer group ob mid:"+data.ob_mid);
          console.log("pc!!", data);

          this.obmidsparameter = data.ob_mids;
          this.midparameter = data.ob_mid;
          // this.getMidStatus(this.midparameter);
          this.statusActions = [
            {
              label: 'prekliči izračiun', icon: 'pi pi-refresh', command: () => {
                this.cancelUserDefinedAreaCalc(this.status);
              },
            }
          ]
        }
        else {
          console.log("load layer group error: data undefined ");

        }
      },
      err => { console.log(err) }
    );


    this.eventService.listenCancleDrawEvent().subscribe({
      next: res => {
        // if (!res) return;
        this.drawInteraction.setActive(false);
        this.modifyInteraction.setActive(false);
        this.vectorDrawLayer.getSource().clear();
        this.drawoptselected = 2;
      }
    })
  }

  private getMidStatus(midparameter) {
    this.remotePowerService.getUserDefinedHeatingAreaStatus(KeycloakService.auth.authz.subject, midparameter).subscribe({
      next: response => {
        this.status = response;
      }
    })
  }


  cancelUserDefinedAreaCalc(status) {
    this.remotePowerService.cancelUserDefinedAreaCalc(status.heatingSystemId).subscribe({
      next: res => {
        this.status = null;
        console.log(res)
      },
      error: err => console.error(err)
    })
  }

  calcSumConsumption(formObj) {
    return (
      Number(formObj.consumptionShareStateBuildings) +
      Number(formObj.consumptionShareMunicipalityBuildings) +
      Number(formObj.consumptionShareMultiAppartmentBuildings) +
      Number(formObj.consumptionShareProductionBuildings) +
      Number(formObj.consumptionShareBusinessBuildings) +
      Number(formObj.consumptionShareTouristicBuildings)
    );
  }

  maxConsumtionLogic() {
    if (this.sumConsumption > 100) {
      this.remotePowerForm.controls['consumptionShareStateBuildings'].setValue(this.consumptionShareStateBuildingsMAX, { emitEvent: false });
      this.remotePowerForm.controls['consumptionShareMunicipalityBuildings'].setValue(this.consumptionShareMunicipalityBuildingsMAX, { emitEvent: false });
      this.remotePowerForm.controls['consumptionShareMultiAppartmentBuildings'].setValue(this.consumptionShareMultiAppartmentBuildingsMAX, { emitEvent: false });
      this.remotePowerForm.controls['consumptionShareProductionBuildings'].setValue(this.consumptionShareProductionBuildingsMAX, { emitEvent: false });
      this.remotePowerForm.controls['consumptionShareBusinessBuildings'].setValue(this.consumptionShareBusinessBuildingsMAX, { emitEvent: false });
      this.remotePowerForm.controls['consumptionShareTouristicBuildings'].setValue(this.consumptionShareTouristicBuildingsMAX, { emitEvent: false });
    }
    else {
      this.lastValue();
    }
  }

  lastValue() {
    this.consumptionShareStateBuildingsMAX = this.remotePowerForm.controls['consumptionShareStateBuildings'].value;
    this.consumptionShareMunicipalityBuildingsMAX = this.remotePowerForm.controls['consumptionShareMunicipalityBuildings'].value;
    this.consumptionShareMultiAppartmentBuildingsMAX = this.remotePowerForm.controls['consumptionShareMultiAppartmentBuildings'].value;
    this.consumptionShareProductionBuildingsMAX = this.remotePowerForm.controls['consumptionShareProductionBuildings'].value;
    this.consumptionShareBusinessBuildingsMAX = this.remotePowerForm.controls['consumptionShareBusinessBuildings'].value;
    this.consumptionShareTouristicBuildingsMAX = this.remotePowerForm.controls['consumptionShareTouristicBuildings'].value;
  }

  ngAfterViewInit() {
    this.mapApi.onMapLoad().subscribe(() => {
      this.vectorDrawLayer = new VectorLayer({
        source: new VectorSource()
      });

      this.mapApi.map.addLayer(this.vectorDrawLayer);

      this.drawInteraction = new Draw({
        source: this.vectorDrawLayer.getSource(),
        type: 'Polygon',
        condition: always
      });

      this.modifyInteraction = new Modify({
        source: this.vectorDrawLayer.getSource(),
        condition: always,
        deleteCondition: (event) => doubleClick(event)
      });

      this.drawInteraction.on('drawstart', () => {
        this.vectorDrawLayer.getSource().clear();
      });

      this.drawInteraction.on('drawend', (event: any) => {
        const polygon = event.feature.getGeometry();
        console.log(polygon);
        console.log(event);
      });

      this.mapApi.map.addInteraction(this.drawInteraction);
      this.mapApi.map.addInteraction(this.modifyInteraction);

      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
    });
  }



  onFindSelectedClicked(event) {
    this.doFindOptsSelected = event.value;
    if (event.value === 1) {
      const foundNode = this.layersService.findNodeById("291")
      this.eventService.sendUnSelectNode(foundNode);
    }
    if (event.value === 2) {
      const foundNode = this.layersService.findNodeById("291")
      this.eventService.sendSelectNode(foundNode);
    }
  }

  public drawAction(d: any, i: number) {
    this.messageService.clear();
    let sel = d.value;
    console.warn("DRAW ACTIN", d)

    if (sel === 1) {
      this.drawInteraction.setActive(true);
      this.modifyInteraction.setActive(false);
    }
    else if (sel === 2) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(true);
    }
    else if (sel === 3) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
      this.vectorDrawLayer.getSource().clear();
      if (!this.infoEvent) return;
      this.deleteCustomHeatingArea(this.infoEvent)
    }
    else if (sel === 4) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
      let polygon = null
      // if (this.infoEvent) {
      //   console.log("infoEvent", this.infoEvent)
      //    polygon = this.infoEvent.feature.getGeometry();
      // // this.vectorDrawLayer.getSource().addFeatures(this.infoEvent.feature)

      // }
      var features = this.vectorDrawLayer.getSource().getFeatures();
      console.warn("FEATURE", features)
      if (features.length > 0) {
        this.messageService.add({ key: 'remotePower', severity: 'info', summary: 'Obvestilo', detail: 'Zahteva za analizo je bila podana !' });
        var poly = features[0].getGeometry();
        this.calculateDrawLayer(poly);

      }
      else if (polygon) {
        this.calculateDrawLayer(polygon);
      }
      else {
        this.messageService.add({ key: 'remotePower', severity: 'error', summary: 'Obvestilo', detail: 'Za zaključek je potrebno vrisati območje analize !' });
      }

    }
  }

  calculateDrawLayer(poly) {
    const format = new WKT();
    const wktRepresenation = format.writeGeometry(poly);
    const rBody: IUserDefArea = {
      mid: this.midparameter,
      userId: KeycloakService.auth.authz.subject,
      wktGeom: wktRepresenation,
    }

    if (this.doFindOptsSelected === 2) {
      rBody.srid = Number(this.mapApi.map.getView().getProjection().getCode().split(":")[1])
    }
    let systemId = null;
    if (this.infoEvent) {
      systemId = Number(this.infoEvent.attributes.id_ogrevalnega_sistema.split('.').join(""));
    }
    // var rBody = { mid: this.midparameter, mids: this.obmidsparameter, wktGeom: wktRepresenation, userId: KeycloakService.auth.authz.subject, geomSrid: this.mapApi.map.getView().getProjection().getCode().split(":")[1] };

    //console.log(this.mapApi.map.getView().getProjection().getCode().split(":")[1]);
    console.log(rBody, systemId);
    this.vectorDrawLayer.getSource().clear();

    this.messageService.add({ key: 'remotePower', severity: 'info', summary: 'Obvestilo', detail: 'Analiza podatkov se je začela !' });

    this.remotePowerService.postUserDefinedHeatingArea(rBody, systemId).subscribe({
      next: (r: any) => {
        console.log("postUserDefinedHeatingArea RESPONSE", r);
        this.getMidStatus(this.midparameter);
        if (r.isValidGeom !== undefined && !r.isValidGeom) {
          this.messageService.add({ key: 'remotePower', severity: 'error', summary: 'Obvestilo', detail: r.msg });
        }
        else {
          this.messageService.add({ key: 'remotePower', severity: 'info', summary: 'Obvestilo', detail: r.msg });
          //this.mapApi.createWfsLayer(this.globalService.getKartoGeoserverUrl(),r.geoserverLayerName,"sse",r.cql,true,true);
          // if (i === 2) {
          this.showData(r);
          this.onCloseEmmiter.emit(true);
          // }
          setTimeout(() => { this.messageService.clear() }, 5000)
        }


      },
      error: (e) => {
        console.error("error", e);
        this.drawInteraction.setActive(false);
        this.modifyInteraction.setActive(false);
        this.vectorDrawLayer.getSource().clear();
        this.messageService.add({ key: 'remotePower', severity: 'error', summary: 'Obvestilo', detail: e._body });
      }
    });
  }

  onSistemTypeSelect(type, index) {
    this.systemSizeTypes[index].selected = !this.systemSizeTypes[index].selected;
  }


  submitForm(): void {
    console.warn(this.remotePowerForm.value);

    const obj: IRemotePower = {
      // minSystemSize: this.minSystemSize,
      // maxSystemSize: this.maxSystemSize,
      sistemSizes: this.systemSizeTypes.filter(type => type.selected).map(type => type.id).sort().join(','),
      minConsumptionDensityInArea: this.remotePowerForm.value.minConsumptionArea ? this.remotePowerForm.value.minConsumptionAreaValue : 0,
      minConsumptionDensityInNetwork: this.remotePowerForm.value.minConsumptionNetwork ? this.remotePowerForm.value.minConsumptionNetworkValue : 0,
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter,
      consumptionShareStateBuildings: this.remotePowerForm.value.isStateBuilding ? this.remotePowerForm.value.consumptionShareStateBuildings : 0,
      consumptionShareMunicipalityBuildings: this.remotePowerForm.value.isMunicipality ? this.remotePowerForm.value.consumptionShareMunicipalityBuildings : 0,
      consumptionShareMultiAppartmentBuildings: this.remotePowerForm.value.isApartments ? this.remotePowerForm.value.consumptionShareMultiAppartmentBuildings : 0,
      consumptionShareProductionBuildings: this.remotePowerForm.value.isProduction ? this.remotePowerForm.value.consumptionShareProductionBuildings : 0,
      consumptionShareBusinessBuildings: this.remotePowerForm.value.isBusiness ? this.remotePowerForm.value.consumptionShareBusinessBuildings : 0,
      consumptionShareTouristicBuildings: this.remotePowerForm.value.isTouristic ? this.remotePowerForm.value.consumptionShareTouristicBuildings : 0

    }
    console.log("obj", obj)
    this.remotePowerService.postRemotePowerAnalisedResults(obj).subscribe(
      {
        next: response => {
          console.warn("RESPONSE", response)
          this.messageService.add({ key: 'remotePower', severity: 'info', summary: 'Obvestilo', detail: response.msg });
          this.showData(response)
          this.onCloseEmmiter.emit({ open: false, msg: { key: 'remotePower', severity: 'info', summary: 'Obvestilo', detail: response.msg } });
        },
        error: err => {
          console.error("Error", err)
          this.onCloseEmmiter.emit({ open: true, msg: { key: 'remotePower', severity: 'error', summary: `Error`, detail: JSON.parse(err._body).msg } });
        }
      }
    )
  }

  public deleteCustomHeatingArea(infoEvent): void {
    console.log(infoEvent.attributes.id_ogrevalnega_sistema.split('.').join(""))
    this.remotePowerService.deleteCustomHeatingArea(Number(infoEvent.attributes.id_ogrevalnega_sistema.split('.').join(""))).subscribe({
      next: res => {
        console.log("Res", res)
        this.messageService.add({ key: 'remotePower', severity: 'info', summary: 'Izbris uspešen!', detail: res.msg });
      },
      error: err => {
        console.error(err)
        this.messageService.add({ key: 'remotePower', severity: 'error', summary: 'Obvestilo', detail: 'Napaka :' + err._body });
      }
    })
  }

  private showData(data: any): void {

    if (data.status === true) {
      let tabels = [];
      if (data.dependendLayerIds) {
        tabels = tabels.concat(data.dependendLayerIds);
      }
      tabels.push(data.webappLayerId);

      console.warn("TABLE", tabels)

      tabels.forEach(id => {

        let node = this.layersService.findNodeById(id);
        console.warn("NODE", node)
        if (node !== null) {
          this.eventService.sendTreeNodeOnOffEvt({ id: id, ison: true });
          node.data.showtable = true;
          node.data.tabledataloaded = false;
          this.tableService.setRequestTableData(node);
          var s1 = this.tableService.subscribeDataListener().subscribe(response => {
            console.warn("response", response)
            this.tableService.setShowTable(node.data.id, true, node.label, node);
            s1.unsubscribe();
          });

          //console.log("find node in tree",node);
        }
      });
    }
  }
}
